import { LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

export function preLoadCalendarBoardAssetExperiments() {
    lazyModule.import();
}

export const EXPERIMENTS_ASSET_REGISTRY = new LazyImport(
    lazyModule,
    m => m.EXPERIMENTS_ASSET_REGISTRY
);
